import React, { useState } from 'react';

const BASE = 'https://mathandsport-b2b.seriea.prd.sdp.deltatre.digital';
const PC   = process.env.REACT_APP_PROJECT_CODE || 'serie-a';

export default function ApiDebug() {
  const [result, setResult]   = useState(null);
  const [loading, setLoading] = useState(false);
  const [path, setPath]       = useState(`/v1/${PC}/football/competitions`);
  const [apiKey, setApiKey]   = useState(process.env.REACT_APP_SERIEA_API_KEY || '');
  const [open, setOpen]       = useState(true);

  if (process.env.NODE_ENV !== 'development') return null;

  async function test(p) {
    setLoading(true); setResult(null);
    const url = `${BASE}${p}`;
    const headers = { Accept: 'application/json' };
    if (apiKey) headers['x-api-key'] = apiKey;
    try {
      const r = await fetch(url, { headers });
      const text = await r.text();
      setResult({ url, status: r.status, body: text.slice(0, 2000) });
    } catch (e) {
      setResult({ url, status: 'NETWORK/CORS ERROR', body: e.message });
    }
    setLoading(false);
  }

  const presets = [
    `/v1/${PC}/football/competitions`,
    `/v1/${PC}/football/seasons/8/matchdays`,
    `/v1/${PC}/football/seasons/8/matches`,
    `/v1/${PC}/football/seasons/8/matches/current`,
  ];

  const sc = !result ? '#aaa'
    : result.status === 200 ? '#22c55e'
    : result.status === 401 ? '#f59e0b'
    : '#e05252';

  return (
    <div style={{
      position:'fixed',bottom:0,right:0,zIndex:9999,background:'#0d1b2a',
      border:'1px solid #2a4060',borderRadius:'10px 0 0 0',
      padding:open?'14px':'8px',maxWidth:520,fontSize:'12px',
      fontFamily:'monospace',color:'#e0e0e0',
      maxHeight:open?'90vh':'auto',overflowY:'auto',
      boxShadow:'0 -4px 20px rgba(0,0,0,0.6)',
    }}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <b style={{color:'#e8c84a'}}>🔧 API Debug</b>
        <button onClick={()=>setOpen(o=>!o)}
          style={{background:'none',border:'none',color:'#aaa',cursor:'pointer',fontSize:14}}>
          {open?'▼':'▲'}
        </button>
      </div>

      {open && <>
        <div style={{marginTop:10}}>
          <label style={{color:'#e8c84a',display:'block',marginBottom:4}}>🔑 x-api-key</label>
          <input value={apiKey} onChange={e=>setApiKey(e.target.value)}
            placeholder="v4QKPkk2KHhZRhzX"
            style={{width:'100%',background:'#152337',border:'1px solid #2a4060',
              color:'#fff',padding:'5px 8px',borderRadius:4,fontSize:11}} />
        </div>

        <div style={{marginTop:10}}>
          <div style={{color:'#7a90a8',marginBottom:6,fontSize:11}}>Preset:</div>
          <div style={{display:'flex',flexWrap:'wrap',gap:5}}>
            {presets.map(p=>(
              <button key={p} onClick={()=>{setPath(p);test(p);}}
                style={{background:'#1e3352',border:'1px solid #333',color:'#ccc',
                  padding:'3px 8px',borderRadius:4,cursor:'pointer',fontSize:10}}>
                {p.replace(`/v1/${PC}/football`,'')||'/competitions'}
              </button>
            ))}
          </div>
        </div>

        <div style={{display:'flex',gap:6,marginTop:8}}>
          <input value={path} onChange={e=>setPath(e.target.value)}
            style={{flex:1,background:'#152337',border:'1px solid #2a4060',color:'#fff',
              padding:'4px 8px',borderRadius:4,fontSize:11}} />
          <button onClick={()=>test(path)}
            style={{background:'#1a7a3c',border:'none',color:'#fff',
              padding:'4px 14px',borderRadius:4,cursor:'pointer',fontWeight:700}}>
            TEST →
          </button>
        </div>

        {loading && <p style={{color:'#aaa',marginTop:8}}>⏳ …</p>}

        {result && (
          <div style={{marginTop:10,borderTop:'1px solid #1e3352',paddingTop:10}}>
            <div style={{color:'#7a90a8',wordBreak:'break-all',fontSize:11,marginBottom:4}}>
              {result.url}
            </div>
            <div>Status: <b style={{color:sc}}>{result.status}</b>
              {result.status===200&&' ✓ FUNZIONA!'}
              {result.status===401&&' ← API key errata/mancante'}
              {result.status===404&&' ← path sbagliato'}
            </div>
            <pre style={{
              marginTop:6,whiteSpace:'pre-wrap',wordBreak:'break-all',
              background:'#152337',padding:8,borderRadius:4,
              maxHeight:220,overflowY:'auto',color:'#ccc',fontSize:11
            }}>{result.body||'(vuoto)'}</pre>
          </div>
        )}
      </>}
    </div>
  );
}
